import { useState, useEffect } from 'react';

const LOGO_URL =
  'https://static.readdy.ai/image/9ce25d869b896a3f5b856271bcc15d01/04593552a0ea563d300a18e4891c8936.jpeg';

const NAV_ITEMS = [
  { label: 'Teenused', href: '#teenused' },
  { label: 'Meist', href: '#meist' },
  { label: 'Kontakt', href: '#kontakt' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const linkBase = scrolled ? 'text-gray-600 hover:text-eco-green' : 'text-white/80 hover:text-white';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
        <a href="#" className="flex items-center h-12 w-auto">
          <img
            src={LOGO_URL}
            alt="IISRAL Recycling OÜ logo"
            className="h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap ${linkBase}`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#kontakt"
            className="bg-eco-green text-white text-sm font-bold px-6 py-2.5 rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-dark-green"
          >
            Võta ühendust
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
            scrolled ? 'text-gray-700' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-8 py-5 flex flex-col gap-4">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-gray-600 font-medium text-sm tracking-wide cursor-pointer hover:text-eco-green transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#kontakt"
            className="bg-eco-green text-white text-sm font-bold px-5 py-2.5 rounded-full text-center cursor-pointer whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            Võta ühendust
          </a>
        </div>
      )}
    </nav>
  );
}
